module.exports = __webpack_public_path__ + "img/Search.fb0dfd64.svg";